// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalForm_wrapper__2p4Ci","show":"ModalForm_show__1FHoG","modal":"ModalForm_modal__3n8pM"};